<template>
  <file
    :get-files-function="getRequiredFiles"
    :upload-file-function="uploadFile"
    :filesData="files"
    :filesPaging="paging"
    :fileContentType="fileContentType"
    :contactLookupsData="contactLookups"
  />
</template>

<script>
//import gridFields from '../../../../../fields';

import Grid from '@/shared/components/Grid';
import File from '@/shared/components/File';
import { mapState, mapActions, mapGetters } from 'vuex';
// import FileForm from './Form';

export default {
  components: {
    Grid,
    File
    // FileForm
  },
  props: ['companyId'],
  data() {
    return {};
  },
  computed: {
    ...mapState('files', ['files', 'paging', 'fileContentType']),
    ...mapState('contacts', ['contacts', 'contactLookups'])
  },
  watch: {
    companyId: {
      async handler() {
        await this.getFiles({ companyId: this.companyId });
      }
    }
  },
  methods: {
    ...mapActions('files', ['getFiles']),
    ...mapActions('files', ['saveFile', 'getFileContentType']),

    async getRequiredFiles(pagingData) {
      await this.getFiles({ companyId: this.companyId, ...pagingData });
    },

    async uploadFile(uploadedFile) {
      if (uploadedFile) {
        uploadedFile.companyId = this.companyId;
        await this.saveFile(uploadedFile);
      }
    }
  },

  async created() {
    await this.getFileContentType();
  }
};
</script>
